module.exports = __webpack_public_path__ + "img/tool_text_active.09d7a392.png";